__turbopack_context__.v({
  "ol": "pt-components-module-scss-module__jPiy3a__ol",
  "ul": "pt-components-module-scss-module__jPiy3a__ul",
});
